module.exports = __webpack_public_path__ + "dash_20_app_assets/img/sharefb.875884e6.png";